<template>
	<div class="nk-toggler-group">
		<div v-if="settings.selectAllCheckBox">
			<nk-checkbox type="checkbox" :tabindex="tabindex" :options="settings.checkboxOptions" @update:modelValue="checkboxClicked" v-model="selectAllChecked" class="nk-toggler-checkbox" />
		</div>
		<div :class="['nk-toggler-items', settings.class]">
			<nk-toggler v-for="(item, index) in localData" @click="(val, selected) => clicked(item, selected)" :key="item.id" :data="item" :options="settings.togglerOptions" :disabled="disabled" :tabindex="tabindex + index + 1"></nk-toggler>
		</div>
	</div>
</template>

<script>
	import Merge from 'lodash/merge'
	import { isEmpty } from '~/statics/validators'
	import _ from 'lodash'

	export default {
		name: 'toggler-group',
		emits: ['update:modelValue', 'click'],
		props: {
			data: { type: Array, required: true },
			modelValue: { required: true },
			options: { type: Object },
			tabindex: { type: [String, Number] },
			startup: { type: Boolean, default: false },
			disabled: { type: Boolean, default: false },
		},
		watch: {
			data: {
				deep: true,
				immediate: true,
				handler(val) {
					this.localData.forEach(x => isEmpty(x.id) ? x.id = this.idGenerator(5) : x.id)
					this.localData = Merge(this.localData, val)
				}
			},
			options: {
				deep: true,
				immediate: true,
				handler(val) {
					this.settings = Merge(this.settings, val)
				}
			},
			modelValue: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					if (val && val !== oldVal) {

						if (!this.settings.multiSelection && Array.isArray(val))
							throw Error('modelValue must be an object when multiSelection=false!')

						if (this.settings.multiSelection && this.isObject(val))
							throw Error('modelValue must be an array when multiSelection=true!')

						this.clicked(val, true, false)
					}
				}
			}
		},
		computed: {
			selecteds() {
				return this.localData.filter(x => x.selected)
			},
		},
		data() {
			return {
				localData: [],
				selectAllChecked: false,
				settings: {
					identifier: 'id',
					checkboxOptions: {
						title: this.$t('select-all')
					},
					multiSelection: true,
					selectAllCheckBox: true,
					togglerOptions: {},
					class: ''
				}
			}
		},
		methods: {
			identifier(item) {
				let id

				if (this.settings.identifier) {
					if (_.isFunction(this.settings.identifier))
						id = this.settings.identifier(item)
					else
						id = this.settings.identifier

					return _.get(item, id)
				}

				return null
			},
			deselectAll() {
				this.localData.forEach(x => x.selected = false)
			},
			selectAll() {
				this.localData.forEach(x => x.selected = true)
			},
			deselect(item) {

				const index = this.localData.findIndex(x => this.identifier(x) === this.identifier(item))
				if (index > -1) {
					this.localData[index].selected = false
				}
			},
			select(val) {

				if (!this.settings.multiSelection)
					this.deselectAll()

				const toSelect = Array.isArray(val) ? val : [val]

				for (const item of toSelect) {
					const index = this.localData.findIndex(x => this.identifier(x) === this.identifier(item))
					if (index > -1) {
						this.localData[index].selected = true
					}
				}
			},
			checkboxClicked(selected) {
				this.clicked(null, selected)
			},
			clicked(item, selected, emit = true) {

				if (item) {
					const data = this.localData.find(x => this.identifier(x) === this.identifier(item))

					if (selected)
						this.select(data)
					if (!selected)
						this.deselect(data)
				}

				else {
					if (selected)
						this.selectAll()
					if (!selected)
						this.deselectAll()
				}

				if (this.localData.every(x => x.selected))
					this.selectAllChecked = true
				else
					this.selectAllChecked = false

				if (emit) {
					const result = this.settings.multiSelection ? this.selecteds : (this.selecteds.length ? this.selecteds[0] : null)
					this.$emit('update:modelValue', result)
					this.$emit('click', result)
				}
			},
		}
	}
</script>

<style lang="less">
	@import "../../styles/toggler.less";
</style>